import classNames from 'classnames';
import { FC, useRef, memo } from 'react';

interface iCheckboxProps {
  label: string;
  value: boolean;
  name: string;
  onChange: (value: boolean) => void;
  error?: string;
}

const Checkbox: FC<iCheckboxProps> = memo(({ label, value, onChange, name, error }) => {
  const id = useRef(`checkbox-${name}-${Math.random()}`).current;
  const _handleChange = ({ target: { checked } }: any) => onChange(checked);
  return (
    <div className={classNames('checkbox-wrapper', error && 'error')}>
      <input id={id} type='checkbox' defaultChecked={value} onChange={_handleChange} />
      <label htmlFor={id}>{label}</label>
    </div>
  );
});

export default Checkbox;
